import Logo from "../../../images/choose.png";
import quality from "../../../images/quality.png";
import experience from "../../../images/experience.png";
import innovation from "../../../images/innovation.png";
export const ChoseTitleData = [
  {
    Title: `Why Choose Us`,
    pera: ` At Qubitars, we are dedicated to providing our clients with the best possible service. With our years of experience, attention to detail, and commitment to customization and communication.`,
    img: Logo,
    key: "2121",
    alt: "img",
  },
];

export const ChoseCommonData = [
  {
    Title: `Quality Assurance`,
    pera: `We are committed to delivering high-quality solutions to our clients. We have a rigorous quality assurance process in place to ensure that our solutions meet the highest standards.`,
    img: quality,
    key: "2121",
    alt: "img",
  },
  {
    Title: `Experience`,
    pera: `Our team has years of experience in the industry, giving us the knowledge and skills needed to deliver exceptional results.`,
    img: experience,
    key: "2121",
    alt: "img",
  },
  {
    Title: ` Innovation`,
    pera: `We pride ourselves on staying up-to-date with the latest industry trends and technologies, bringing innovation and creativity to every project.`,
    img: innovation,
    key: "2121",
    alt: "img",
  },
];
